import { get, values } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getItemSkus = get('inventory.itemSkus');

export const getSkusByItemId = createSelector(getItemSkus, get('byItemId'));

export const getSkusForItemId = createSelector(
  (_, itemId) => itemId,
  getSkusByItemId,
  get
);

export const getSkusListForItemId = createSelector(getSkusForItemId, values);

export const getIsFetching = createSelector(getItemSkus, get('fetching'));
export const getIsFetched = createSelector(getItemSkus, get('fetched'));
export const getFetchingError = createSelector(
  getItemSkus,
  get('fetchingError')
);

export const getIsSaving = createSelector(getItemSkus, get('saving'));
export const getIsSaved = createSelector(getItemSkus, get('saved'));
export const getSavingError = createSelector(getItemSkus, get('savingError'));

export const getIsDeleting = createSelector(getItemSkus, get('deleting'));
export const getIsDeleted = createSelector(getItemSkus, get('deleted'));
export const getDeletingError = createSelector(
  getItemSkus,
  get('deletingError')
);
